import React, { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { callUserStringApi, createApiPoller } from '../utils/apiService';

const UserStringCapture = ({ isAuthenticated }) => {
  const { getAccessTokenSilently, isAuthenticated: auth0IsAuthenticated, loginWithRedirect } = useAuth0();
  const pollerRef = useRef(null);

  useEffect(() => {
    console.log('UserStringCapture component mounted');
    
    // Create API call function that actively checks authentication status
    const apiCallFunction = async () => {
      try {
        // Always try to get a fresh access token to check current auth status
        const accessToken = await getAccessTokenSilently({ ignoreCache: true });
        console.log('Got fresh access token, length:', accessToken?.length);
        
        // Check if we actually have a valid token (not just cached)
        if (accessToken && accessToken.length > 0) {
          await callUserStringApi(accessToken, true);
        } else {
          console.log('No valid access token found, treating as unauthenticated');
          await callUserStringApi(null, false);
        }
      } catch (error) {
        console.log('Error getting access token:', error.message || error);
        
        // If we can't get the token, try to refresh the page to trigger re-auth
        if (error.message && (error.message.includes('Login required') || error.message.includes('login_required'))) {
          console.log('Authentication required, sending logout status then refreshing page');
          // Send postMessage first, then refresh
          await callUserStringApi(null, false);
          setTimeout(() => {
            window.location.reload();
          }, 100); // Small delay to ensure postMessage is sent
          return;
        }
        
        // For other errors, treat as unauthenticated
        await callUserStringApi(null, false);
      }
    };
    
    // Call API immediately
    apiCallFunction();
    
    // Set up polling using the shared service
    pollerRef.current = createApiPoller(apiCallFunction, 15000);
    pollerRef.current.start();
    
    // Cleanup on unmount
    return () => {
      if (pollerRef.current) {
        pollerRef.current.stop();
      }
    };
  }, [getAccessTokenSilently, loginWithRedirect]);

  // Return minimal UI - just a loading indicator or nothing
  return (
    <div style={{ 
      padding: '20px', 
      fontFamily: 'Arial, sans-serif',
      textAlign: 'center',
      color: '#666'
    }}>
      <p>Processing...</p>
      <small>Polling API every 15 seconds</small>
    </div>
  );
};

export default UserStringCapture;
